import { useDispatch } from 'react-redux';
import '../../css/base.css';
import { setActivity } from '../../store/AppSlice';
import sandaig1_small from '../../img/walks/sandaig1_small.jpg'; 
import sandaig1_medium from '../../img/walks/sandaig1_medium.jpg'; 
import sandaig1_large from '../../img/walks/sandaig1_large.jpg'; 
import sandaig2_small from '../../img/walks/sandaig2_small.jpg'; 
import sandaig2_medium from '../../img/walks/sandaig2_medium.jpg'; 
import sandaig2_large from '../../img/walks/sandaig2_large.jpg'; 

const WalkSandaigDetails = () => {

  const dispatch = useDispatch();

  const navigateToActivity = () => {
    dispatch(setActivity(""));
  }

  return (
    <div className="row">
    <div className="col-12 imagesBackgroundColour">
        <div className="generalTextBox">
          <p className="activity-back-button">
            <span className="navigate-span"><a className="navigate-button" onClick={navigateToActivity}>Back</a></span>
          </p>
        </div>
    </div>
    <div className="col-12 imagesBackgroundColour">
        <div className="generalText">
          <div className="generalTextBox">
            <h2 className="walks-section-heading">Sandaig</h2>
            <p className="walk-text">Try and pick a sunny day at close to low tide so you can explore the small islands.
            </p>
            <h3 className="walks-detail-heading"><strong>Directions</strong></h3>
            <p className="walk-directions">1. Park on the roadside a few hundred metres past the only house on the road about 6 miles from Arnisdale towards Glenelg.
            </p>      
            <p className="walk-directions">2. Walk through the forestry gate.
            </p>      
            <p className="walk-directions">3. At a T junction turn left.
            </p>      
            <p className="walk-directions">4. There are two options to get down. The easiest is to continue over a bridge and along for half a mile and then turn right to head down to Sandaig. The alternative steeper quicker route is a right turn just before the bridge. About 20m along this track you will see a small path off to the left. You can follow this down steeply to the bottom.
            </p>      
            <p className="walk-directions">5. Once in Sandaig you are either on the beach side or the islands side with the rope bridge to cross between the two. Or a plodge through the river.
            </p>      
            <p className="walk-directions">6. Return either route.
            </p>      
            <h3 className="walks-detail-heading"><strong>Time</strong></h3>
            <p className="walk-text">45 mins walk each way
            </p>                                           
          </div>
        </div>
      </div>
      <div className="col-12 imagesBackgroundColour walk-image">
      <picture>
        <source srcSet={`${sandaig1_small} 1x,${sandaig1_medium} 2x`} media="(max-width: 600px)" />
        <img srcSet={`${sandaig1_medium} 1x,${sandaig1_large} 2x`}
          src={sandaig1_medium} alt="Sandaig Wideangle" className="image"
        />
      </picture>
    </div>
    <div className="col-12 imagesBackgroundColour walk-image">
    <picture>
        <source srcSet={`${sandaig2_small} 1x,${sandaig2_medium} 2x`} media="(max-width: 600px)" />
        <img srcSet={`${sandaig2_medium} 1x,${sandaig2_large} 2x`}
          src={sandaig2_medium} alt="Sandaig Winter" className="image"
        />
      </picture>
    </div>
    <div className="col-12 imagesBackgroundColour">
      <div className="generalText">
          <div className="generalTextBox">
            <p className="activity-back-button">
              <span className="navigate-span"><a className="navigate-button" onClick={navigateToActivity}>Back</a></span>
            </p>
          </div>
      </div>
    </div>
    </div>
  );
}

export default WalkSandaigDetails
